var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopicLayers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#EEF2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7300_234420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16626 12.0016C6.16599 12.1132 6.19771 12.2225 6.25769 12.3166C6.31766 12.4107 6.40336 12.4856 6.50462 12.5325L11.5216 14.8135C11.6728 14.8819 11.8369 14.9173 12.0029 14.9173C12.1689 14.9173 12.333 14.8819 12.4842 14.8135L17.4896 12.5383C17.5928 12.4919 17.6803 12.4165 17.7415 12.3212C17.8026 12.2259 17.8346 12.1148 17.8337 12.0016M6.16626 14.9185C6.16599 15.03 6.19771 15.1394 6.25769 15.2334C6.31766 15.3275 6.40336 15.4025 6.50462 15.4493L11.5216 17.7303C11.6728 17.7988 11.8369 17.8342 12.0029 17.8342C12.1689 17.8342 12.333 17.7988 12.4842 17.7303L17.4896 15.4552C17.5928 15.4087 17.6803 15.3333 17.7415 15.238C17.8026 15.1427 17.8346 15.0317 17.8337 14.9185M12.4845 6.27318C12.3325 6.20385 12.1673 6.16797 12.0003 6.16797C11.8332 6.16797 11.6681 6.20385 11.5161 6.27318L6.51655 8.54831C6.41303 8.59395 6.32501 8.66872 6.26323 8.76349C6.20144 8.85826 6.16854 8.96895 6.16854 9.08209C6.16854 9.19522 6.20144 9.30592 6.26323 9.40069C6.32501 9.49546 6.41303 9.57022 6.51655 9.61587L11.5219 11.8968C11.6739 11.9662 11.839 12.002 12.0061 12.002C12.1732 12.002 12.3383 11.9662 12.4903 11.8968L17.4956 9.6217C17.5992 9.57606 17.6872 9.5013 17.749 9.40653C17.8108 9.31175 17.8437 9.20106 17.8437 9.08792C17.8437 8.97479 17.8108 8.86409 17.749 8.76932C17.6872 8.67455 17.5992 8.59979 17.4956 8.55414L12.4845 6.27318Z",
    stroke: "#464AEF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7300_234420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicLayers);
export default __webpack_public_path__ + "static/media/topic-layers.d481c90048970f3b864e2c879c25f245.svg";
export { ForwardRef as ReactComponent };